import React, { useState } from 'react';

/** Keyword chips with an add box; Enter or "Add" adds a tag. */
const TagInput = ({ tags, onChange, error, placeholder = 'e.g. fractions, worksheet' }) => {
  const [newTag, setNewTag] = useState('');

  const add = () => {
    const values = newTag.split(',').map((t) => t.trim()).filter(Boolean);
    const next = [...tags];
    values.forEach((v) => {
      if (!next.includes(v)) next.push(v);
    });
    if (next.length !== tags.length) onChange(next);
    setNewTag('');
  };

  return (
    <div>
      <div className="flex gap-2">
        <input
          type="text"
          placeholder={placeholder}
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          className={`flex-1 rounded-lg border px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 focus:outline-none transition-shadow ${
            error ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-300'
          }`}
        />
        <button
          type="button"
          onClick={add}
          className="px-4 py-2 rounded-lg text-sm font-medium text-brand-600 bg-brand-50 border border-brand-200 hover:bg-brand-100 transition-colors"
        >
          Add
        </button>
      </div>
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {tags.map((tag) => (
            <span key={tag} className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 pl-2.5 pr-1.5 py-1 rounded-md text-xs font-medium">
              {tag}
              <button
                type="button"
                onClick={() => onChange(tags.filter((t) => t !== tag))}
                className="ml-0.5 text-gray-400 hover:text-red-500 transition-colors"
                aria-label={`Remove ${tag}`}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagInput;
